/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var LocalVariantSelection = /** @class */ (function () {
        function LocalVariantSelection() {
        }
        LocalVariantSelection.updateForm = function (variantSelection) {
            if (this.outOfStock) {
                return;
            }
            var currentVariant = variantSelection.getSelectedVariant();
            var submitButton = variantSelection.getFormEl().querySelector('.controls button');
            if (currentVariant.stock === 0) {
                submitButton.innerText = 'Vara uppseld';
                submitButton.disabled = true;
            }
            else {
                submitButton.innerText = 'Setja í körfu';
                submitButton.disabled = false;
            }
        };
        LocalVariantSelection.showOutOfStock = function (form) {
            form.querySelector('.controls .outOfStockLabel').classList.remove('hidden');
            form.querySelector('.controls button').classList.add('hidden');
            this.outOfStock = true;
        };
        LocalVariantSelection.changeReference = function (data) {
            var referenceElement = document.querySelector('.buyBox .storeReference .value');
            referenceElement.innerHTML = data.variantSelection.selectedVariant.reference;
        };
        LocalVariantSelection.outOfStock = false;
        return LocalVariantSelection;
    }());
    MoyaEventHandler.on('store.variantSelectionInit', function (data) {
        var allVariantsOutOfStock = true;
        data.variantSelection.getVariantCollection().forEach(function (item) {
            if (item.stock > 0) {
                allVariantsOutOfStock = false;
            }
        });
        if (allVariantsOutOfStock) {
            LocalVariantSelection.showOutOfStock(data.variantSelection.getFormEl());
        }
        else {
            LocalVariantSelection.updateForm(data.variantSelection);
        }
    });
    MoyaEventHandler.on('store.variantSelectionReplaceHTML', function (data) {
        LocalVariantSelection.updateForm(data.variantSelection);
        LocalVariantSelection.changeReference(data);
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
